/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ countLabel: NonNullable<unknown> }} Intro_Pool_Size_Mixed_DescriptionInputs */

const bn_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} মাঝারি অসুবিধা সহ।`)
};

const de_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} mit mittlerem Schwierigkeitsgrad.`)
};

const el_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} με μέτρια δυσκολία.`)
};

const en_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} with medium difficulty.`)
};

const es_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} con dificultad media.`)
};

const fr_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} avec une difficulté moyenne.`)
};

const hi_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} मध्यम कठिनाई के साथ।`)
};

const hu_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} közepes nehézségű.`)
};

const id_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} dengan tingkat kesulitan sedang.`)
};

const it_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} con difficoltà media.`)
};

const ja_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} の難易度は中程度です。`)
};

const ko_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 중간 난이도.`)
};

const nl_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} met gemiddelde moeilijkheidsgraad.`)
};

const pl_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} o średnim stopniu trudności.`)
};

const pt_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} com dificuldade média.`)
};

const ru_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} средней сложности.`)
};

const sv_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} med medelsvårighet.`)
};

const tr_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} orta zorlukta.`)
};

const uk_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} із середньою складністю.`)
};

const vi_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} với độ khó trung bình.`)
};

const zh_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 中等难度。`)
};

const zh_hant_intro_pool_size_mixed_description = /** @type {(inputs: Intro_Pool_Size_Mixed_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 中等難度。`)
};

/**
* | output |
* | --- |
* | "{countLabel} with medium difficulty." |
*
* @param {Intro_Pool_Size_Mixed_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_pool_size_mixed_description = /** @type {((inputs: Intro_Pool_Size_Mixed_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Pool_Size_Mixed_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_pool_size_mixed_description(inputs)
	if (locale === "de") return de_intro_pool_size_mixed_description(inputs)
	if (locale === "el") return el_intro_pool_size_mixed_description(inputs)
	if (locale === "en") return en_intro_pool_size_mixed_description(inputs)
	if (locale === "es") return es_intro_pool_size_mixed_description(inputs)
	if (locale === "fr") return fr_intro_pool_size_mixed_description(inputs)
	if (locale === "hi") return hi_intro_pool_size_mixed_description(inputs)
	if (locale === "hu") return hu_intro_pool_size_mixed_description(inputs)
	if (locale === "id") return id_intro_pool_size_mixed_description(inputs)
	if (locale === "it") return it_intro_pool_size_mixed_description(inputs)
	if (locale === "ja") return ja_intro_pool_size_mixed_description(inputs)
	if (locale === "ko") return ko_intro_pool_size_mixed_description(inputs)
	if (locale === "nl") return nl_intro_pool_size_mixed_description(inputs)
	if (locale === "pl") return pl_intro_pool_size_mixed_description(inputs)
	if (locale === "pt") return pt_intro_pool_size_mixed_description(inputs)
	if (locale === "ru") return ru_intro_pool_size_mixed_description(inputs)
	if (locale === "sv") return sv_intro_pool_size_mixed_description(inputs)
	if (locale === "tr") return tr_intro_pool_size_mixed_description(inputs)
	if (locale === "uk") return uk_intro_pool_size_mixed_description(inputs)
	if (locale === "vi") return vi_intro_pool_size_mixed_description(inputs)
	if (locale === "zh") return zh_intro_pool_size_mixed_description(inputs)
	return zh_hant_intro_pool_size_mixed_description(inputs)
});